var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2195_1487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4547 18.301C16.6683 18.301 20.0841 14.9866 20.0841 10.898C20.0841 6.80952 16.6683 3.49512 12.4547 3.49512C8.24103 3.49512 4.8252 6.80952 4.8252 10.898C4.8252 14.9866 8.24103 18.301 12.4547 18.301Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0167 0.91748C13.081 1.26552 12.2232 1.78538 11.4904 2.44859C11.2309 2.75996 11.0319 3.11458 10.9033 3.4951H14.0167V0.91748Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5744 3.7787C18.6397 3.44529 17.6476 3.28952 16.6522 3.31988C16.2462 3.38863 15.8565 3.52837 15.502 3.7323L17.8344 5.71707L19.5744 3.7787Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8893 8.89768C22.2463 8.15798 21.4626 7.54537 20.5808 7.09335C20.1937 6.9564 19.7841 6.88914 19.3721 6.89487L20.3762 9.73025L22.8893 8.89768Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1351 15.0634C22.0371 14.0987 21.7484 13.1615 21.285 12.3028C21.0415 11.9768 20.7391 11.6964 20.3924 11.4753L19.5742 14.3777L22.1351 15.0634Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4937 20.0666C18.0292 19.248 18.3972 18.337 18.5776 17.3833C18.5953 16.9839 18.5376 16.5847 18.4075 16.2053L15.9131 17.9968L17.4937 20.0666Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9033 21.0823C11.8374 20.7286 12.6925 20.2035 13.4217 19.5357C13.6786 19.2288 13.8766 18.8795 14.0061 18.5046H10.9033V21.0823Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 18.2725C6.06368 18.5326 7.06843 18.6105 8.06091 18.5019C8.46109 18.4025 8.83921 18.2331 9.17664 18.0018L6.68749 16.1975L5.10156 18.2725Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08105 12.4472C2.65898 13.2377 3.38869 13.9124 4.23017 14.4346C4.6052 14.6018 5.00848 14.7014 5.42028 14.7284L4.65521 11.8105L2.08105 12.4472Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79004 6.26099C2.88674 7.22522 3.17353 8.16243 3.63481 9.02162C3.87448 9.34718 4.17336 9.62757 4.51677 9.84904L5.35091 6.95952L2.79004 6.26099Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62498 1.86597C7.07862 2.67736 6.69804 3.58306 6.50393 4.53381C6.47959 4.93384 6.53091 5.33483 6.65535 5.71693L9.17638 3.959L7.62498 1.86597Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 12.8028C13.5328 12.8028 14.407 11.9546 14.407 10.9082C14.407 9.86189 13.5328 9.01367 12.4545 9.01367C11.3761 9.01367 10.502 9.86189 10.502 10.9082C10.502 11.9546 11.3761 12.8028 12.4545 12.8028Z",
    stroke: "#58595B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2195_1487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearIcon);
export default __webpack_public_path__ + "static/media/gear-icon.ce97fd994d5a468377a79d8457b31fb5.svg";
export { ForwardRef as ReactComponent };